import React, { useEffect, useState } from 'react'
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import UiInput from '../../../../_uiComponents/telerikComponents/UiInput'

import UiDropDownList from '../../../../_uiComponents/telerikComponents/UiDropDownList';
import {
    UiButton,
} from "../../../../_uiComponents/common/form/UiButton";
import { MainLeftTitle } from "../../../../_uiComponents/WrapperComponents";
import { UiBackButton } from '../../../../_uiComponents/common/form/UiButton';
import { useDispatch } from 'react-redux';
import { participantGetApplicationRequest, participantGetAreasRequest, participantGetDealersRequest, participantGetRolesRequest, participantSaveNewParticipantRequest } from '../../../../../_redux/_actions';
import { useSelector } from 'react-redux';
import { UiSwitch } from '../../../../_uiComponents/telerikComponents/UiSwitch';


export default function AddParticipants(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isChecked, setIschecked] = useState(true);

    const dealerNameValidator = value => value ? '' : 'Dealer Name is required.';
    const dealerCodeValidator = value => value ? '' : 'Dealer Code is required.';
    const locationValidator = value => value ? '' : 'Location is required.';
    const postalCodeValidator = value => value ? '' : 'Postal Code is required.';
    const areaValidator = value => value ? '' : 'Area is required.';

    const handleSubmit = dataItem => {
        // const payload = {
        //     ApplicationId: applicationType,
        //     DealershipId: dealerType === null ? jobRoleList[0].id : dealerType,
        //     JobRoleId: jobRoleType === null ? dealerList[0].id : jobRoleType,
        //     Email: dataItem.email,
        //     FirstName: dataItem.firstName,
        //     LastName: dataItem.lastName,
        //     Active: isChecked
        // }

    }

    const areas = [
        {
            label: "Area 1",
            value: 1,
        },
        {
            label: "Area 2",
            value: 2,
        },
        {
            label: "Area 3",
            value: 3,
        }

    ];

    return (
        <>
            <MainLeftTitle title="Add Dealers" />
            <Form onSubmit={handleSubmit}
                render={formRenderProps =>
                    <Grid container spacing={2}>
                        <div className="sba-input-areas-wr">


                            <Grid item xs={12} lg={6} sx={{ mt: 1 }}>

                                <Field name={'areas'}
                                    component={UiDropDownList}
                                    labelClassName={'k-form-label'}
                                    data={areas}
                                    label={'Areas'}
                                    validator={areaValidator}
                                // value={applicationType}
                                // handleChange={setApplicationType}
                                />
                            </Grid>



                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'dealerCode'}
                                    validator={dealerCodeValidator}
                                    component={UiInput}
                                    labelClassName={'k-form-label'}
                                    label={'Dealer code'} />
                            </Grid>

                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'dealerName'}
                                    validator={dealerNameValidator}
                                    component={UiInput}
                                    labelClassName={'k-form-label'}
                                    label={'Dealer name'} />
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'location'}
                                    component={UiInput}
                                    validator={locationValidator}
                                    labelClassName={'k-form-label'}
                                    label={'Last name'} />
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'postalCode'}
                                    component={UiInput}
                                    validator={postalCodeValidator}
                                    labelClassName={'k-form-label'}
                                    label={'Postal Code'} />
                            </Grid>

                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'status'}
                                    component={UiSwitch}
                                    labelClassName={'k-form-label'}
                                    handleChange={setIschecked}
                                    isChecked={isChecked}
                                    label={'Status'} />
                            </Grid>

                            <Grid item xs={12}>
                                <Stack
                                    spacing={2}
                                    direction="row"
                                    justifyContent="space-between"
                                    sx={{ width: "100%", mt: 1.5 }}
                                >
                                    <UiBackButton size="small" onClick={() => navigate(-1)} />
                                    <div className="sbt-right-action-btn-wr">
                                        <UiButton
                                            name="Cancel"
                                            variant="outlined"
                                            size="small"
                                            onClick={formRenderProps.onFormReset}
                                        />
                                        <UiButton
                                            name="Save"
                                            variant="contained"
                                            size="small"
                                            onClick={formRenderProps.onSubmit}
                                            disabled={!formRenderProps.allowSubmit}
                                        />

                                    </div>
                                </Stack>
                            </Grid>
                        </div>
                    </Grid>
                }
            />

        </>
    );
}